import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

export default class extends Controller {
    connect() {
        // Config https://splidejs.com/guides/options/
        const config = {
            lazyLoad: 'nearby',
            autoWidth: true,
            focus: 'left',
            pagination: false,
            type: 'loop',
            speed: 1000,
            autoplay: true,
        };

        const additionalConfig = this.element.dataset.splideConfig ? JSON.parse(this.element.dataset.splideConfig) : {};

        console.log(additionalConfig);

        // eslint-disable-next-line guard-for-in
        for (const obj in additionalConfig) {
            config[obj] = additionalConfig[obj];
        }

        this.splide = new Splide(this.element, config);
        this.splide.mount();
    }

    go({ params, target }) {
        this.splide.go(params.index);

        for (const element of this.element.querySelectorAll('.slider-menu-item')) {
            element.classList.remove('active');
        }

        target.classList.add('active');
    }
}
